var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5H8.865C8.55 0.63 7.725 0 6.75 0C5.775 0 4.95 0.63 4.635 1.5H1.5C0.675 1.5 0 2.175 0 3V13.5C0 14.325 0.675 15 1.5 15H12C12.825 15 13.5 14.325 13.5 13.5V3C13.5 2.175 12.825 1.5 12 1.5ZM6.75 1.5C7.1625 1.5 7.5 1.8375 7.5 2.25C7.5 2.6625 7.1625 3 6.75 3C6.3375 3 6 2.6625 6 2.25C6 1.8375 6.3375 1.5 6.75 1.5ZM6.75 4.5C7.995 4.5 9 5.505 9 6.75C9 7.995 7.995 9 6.75 9C5.505 9 4.5 7.995 4.5 6.75C4.5 5.505 5.505 4.5 6.75 4.5ZM11.25 13.5H2.25V12.45C2.25 10.95 5.25 10.125 6.75 10.125C8.25 10.125 11.25 10.95 11.25 12.45V13.5Z",
    fill: "#B12D84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.48942d966a600290c48d67b476c959d0.svg";
export { ForwardRef as ReactComponent };